import { TextField, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export interface ValueAndName {
  value: number | string;
  name: string;
}
export interface NumParams {
  target: ValueAndName;
}

export const defaultRates = {
  minRate: 0,
  maxRate: 0,
};

export const RateFilter = ({ setRates }: { setRates: (minRate: number, maxRate: number | null) => void }) => {
  const theme = useTheme();

  const isFirstRender = useRef<boolean>(true);

  const [numberFrom, setNumberFrom] = useState<number>(defaultRates.minRate);
  const [numberTo, setNumberTo] = useState<number | null>(defaultRates.maxRate);

  const handleChangeNumber = ({ target: { value, name } }: { target: { value: string; name: string } }) => {
    name === "from" ? setNumberFrom(+value) : value === "" ? setNumberTo(null) : setNumberTo(Number(value));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timeout = setTimeout(() => {
      setRates(numberFrom, numberTo);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [numberFrom, numberTo, isFirstRender]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <Typography
        style={{ color: theme.palette.text.disabled }}
        variant={"h5"}
      >
        Rate:
      </Typography>
      <TextField
        label={"From"}
        type="number"
        name="from"
        value={numberFrom === 0 ? numberFrom : +numberFrom}
        onChange={handleChangeNumber}
        InputProps={{
          inputProps: { min: 0, step: 1, style: { padding: "10px" } },
        }}
        sx={{ width: "80px" }}
        onBlur={handleChangeNumber}
      />
      {"-"}
      <TextField
        label={"To"}
        type="number"
        name="to"
        value={numberTo === null ? null : numberTo === 0 ? numberTo : Number(numberTo)}
        onChange={handleChangeNumber}
        InputProps={{
          inputProps: { step: 1, style: { padding: "10px" } },
        }}
        sx={{ width: "80px" }}
        onBlur={handleChangeNumber}
      />
    </div>
  );
};
